import React from 'react';
import { useMediaQuery } from 'react-responsive';
import ProjectAnnouncementsCarousel from 'components/organisms/projectAnnouncementsCarousel';
import ProjectAnnouncementsMobileCarousel from 'components/organisms/projectAnnouncementsMobileCarousel';
import { useViewport } from 'components/templates/viewportProvider';

export const ProjectAnnouncementsSection = props => {
  const { data } = props;
  const { announcements, onGetInTouchClick, checkForCTAButton = false } = data;

  const { height } = useViewport();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  return (
    <div style={{ height }} id={'announcements'}>
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <ProjectAnnouncementsCarousel
            announcements={announcements}
            onGetInTouchClick={onGetInTouchClick}
            checkForCTAButton={checkForCTAButton}
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <>
          <ProjectAnnouncementsMobileCarousel
            announcements={announcements}
            onGetInTouchClick={onGetInTouchClick}
            checkForCTAButton={checkForCTAButton}
          />
        </>
      )}
    </div>
  );
};
